import { Grid, makeStyles, Box, Typography } from '@material-ui/core';
import MROTextField from 'components/form_components/TextField';
import React, { useContext, useEffect, useState } from 'react'
import CommonDialog from 'views/Operations/Base/Inprogress/CommonDialog';
import { ToastMessageContext } from 'lib/contexts/message_context';
import WarningIcon from "@material-ui/icons/Warning";
import PlanningLineMaintenance from 'lib/services/api/planning/LineMaintenance/lineEventsandSeries';

const useStyles = makeStyles(() => ({
    modal: {
        "& .MuiDialog-paperWidthMd": {
            maxWidth: "600px",
            padding: '15px'
        },
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },

}))
export default function EditFlight(props) {
    const classes = useStyles()
    const { handleClose, eventDetails, onClose, eventId } = props
    const [loading, setLoading] = useState(false)
    const [arrFlight, setArrFlight] = useState("")
    const [errors, setErrors] = useState({});
    const message = useContext(ToastMessageContext)
    const validateFlightNumber = (flight, flightType) => {
        const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/;
        if (!flight) {
            return `Please enter ${flightType} Flight# `;
        }
        if (!regex.test(flight)) {
            return `${flightType} Flight# must contain letters and numbers`;
        }
        return null; // Valid case
    };



    const handleSubmit = async (e) => {
        e.preventDefault()
        const formdata = new FormData(e.target)
        let valid = true;
        let error = {};
        const arrFlightError = validateFlightNumber(arrFlight, 'Arrival');
        if (arrFlightError) {
            valid = false;
            error.arr_flight_number = arrFlightError;
        }

        if (!valid) {
            setErrors(error);
            return;
        }
        setLoading(true)
        formdata.append("event_id", eventId)
        await PlanningLineMaintenance.updateLineEventsFlightNumber(formdata).then((res) => {
            if (res.success) {
                message.showToastMessage({
                    message: "Flight number updated successfully !",
                    variant: "success",
                });
                onClose()
                setLoading(false)
            }
        }).catch((res) => {
            message.showToastMessage({
                message: res.error ? res.error : "Something went wrong. Try again!",
                variant: "error",
            });
        })
    }

    const resetErrorsHandler = (name) => {
        setErrors((e) => ({ ...e, [name]: false }));
    };

    useEffect(() => {
        if (eventDetails !== undefined) {
            setArrFlight(eventDetails?.arr_flight_number)
        }
    }, [eventDetails])



    return (
        <CommonDialog
            title="Edit LM Event Flight #"
            onClose={onClose}
            onSubmit={handleSubmit}
            loading={loading}
            submitLabel="Complete"
            edit={true}
            paddingleft={"183px"}
            classes={classes.modal}
        >

            <Grid item style={{ paddingBottom: '8px' }} xs={12}>
                <Box display="flex" alignItems="center">
                    <WarningIcon
                        style={{
                            color: "#FFB300",
                            marginRight: "10px",
                            fontSize: 20,
                        }}
                    />
                    <Typography style={{ fontSize: "14px" }}>
                        Removes any existing Flight Radar data and updates the LM Event ready to receive new data from the correct flight (if still in flight)
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} style={{ padding: "0px 75px" }}>
                <MROTextField
                    name={'arr_flight_number'}
                    label={'Arrival Flight # *'}
                    placeholder="Flight # must match flight radar"
                    error={errors.arr_flight_number}
                    inputProps={{ maxLength: 20 }}
                    value={arrFlight}
                    helperText={errors.arr_flight_number ? errors.arr_flight_number : null}
                    onChange={(e) => {
                        resetErrorsHandler("arr_flight_number")
                        let val = e.target.value;
                        if (val) {
                            val = val.replace(/[^\w\s]/g, "");
                            setArrFlight(val);

                        }
                        else {
                            setArrFlight(e.target.value)
                        }
                    }}
                    InputLabelProps={{ shrink: true }}>
                </MROTextField>


            </Grid>

        </CommonDialog>
    )
}
